import { DashboardCaseProduct } from "./dashboardCaseProduct";

export class DashboardRecord {
    id: number;
    firstName: string;
    lastName: string;
    caseProducts: DashboardCaseProduct[];
    dateInitiated: string;
    closedDate: string | null;
    status: string;
    package: string;
    location: string;
    clearResult: boolean;
    resultsWithAlerts: boolean;
    needsInfo: boolean;
    processing: boolean;
    pendingCandidate: boolean;
    awaitingCandidateInvite: boolean;
    finalReportURL: string;
    hasInvoice: boolean;
    hasOutstandingBalance: boolean;
    outstandingTotal: number;
    email: string;
    caseCount: number;
}
